import { useCallback, useEffect, useState } from "react";
import { taskApi } from "../backend/client";

export const isClientVisibleTask = (t: any) =>
  t.visible_to_client === true && t.is_hidden !== true && t.included_in_package !== false;

export const taskLabel = (t: any) => t?.client_title ?? t?.title ?? "";

export function useProjectTasks(projectId: string | number | null | undefined) {
  const [tasks, setTasks] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchTasks = useCallback(async () => {
    if (projectId == null) {
      setTasks([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const { data, error } = await taskApi.listForProject(projectId, {
      order: "task_number",
      ascending: true,
    });
    if (error) {
      setError(error.message || "Could not load tasks.");
      setTasks([]);
    } else {
      setError("");
      setTasks(data || []);
    }
    setLoading(false);
  }, [projectId]);

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  const visibleTasks = tasks.filter(isClientVisibleTask);
  const totalTasks = visibleTasks.length;
  const completedList = visibleTasks.filter((t) => t.is_complete);
  const upcomingList = visibleTasks.filter((t) => !t.is_complete);
  const completedTasks = completedList.length;
  const percentageComplete =
    totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;
  const currentStep = totalTasks
    ? completedTasks < totalTasks
      ? completedTasks + 1
      : totalTasks
    : 1;
  const currentTaskLabel = upcomingList[0]
    ? taskLabel(upcomingList[0])
    : taskLabel(visibleTasks.at(-1) || {}) || "Project not started";

  return {
    tasks,
    visibleTasks,
    totalTasks,
    completedList,
    upcomingList,
    completedTasks,
    percentageComplete,
    currentStep,
    currentTaskLabel,
    loading,
    error,
    refetch: fetchTasks,
  };
}
